import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { APIS } from "../../../../utils/APIS";
import { GET, POST } from "../../../../utils/Methods";
import { IDS } from "../../../../utils/IDS";

export const Create1 = createAsyncThunk(
  "student/auth/registration1",
  async (data, { rejectWithValue }) => {
    try {
      const res = await POST(APIS.Student.Registration1, data);
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const Create2 = createAsyncThunk(
  "student/auth/registration2",
  async (data, { rejectWithValue }) => {
    try {
      const res = await POST(APIS.Student.Registration2, data);
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const Create3 = createAsyncThunk(
  "student/auth/registration3",
  async (data, { rejectWithValue }) => {
    try {
      const res = await POST(APIS.Student.Registration3, data);
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const Create4 = createAsyncThunk(
  "student/auth/registration4",
  async (data, { rejectWithValue }) => {
    try {
      const res = await POST(APIS.Student.Registration4, data);
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const Create5 = createAsyncThunk(
  "student/auth/registration5",
  async (data, { rejectWithValue }) => {
    try {
      const res = await POST(APIS.Student.Registration5, data);
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

// ===== GET / FETCH =====
export const GetRegistration1 = createAsyncThunk(
  "student/auth/get-registration1",
  async (id, { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Student.GetRegistration1}/${id}`);
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const GetRegistration2 = createAsyncThunk(
  "student/auth/get-registration2",
  async (id, { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Student.GetRegistration2}/${id}`);
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const GetRegistration3 = createAsyncThunk(
  "student/auth/get-registration3",
  async (id, { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Student.GetRegistration3}/${id}`);
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const GetRegistration4 = createAsyncThunk(
  "student/auth/get-registration4",
  async (id, { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Student.GetRegistration4}/${id}`);
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const GetRegistration5 = createAsyncThunk(
  "student/auth/get-registration5",
  async (id, { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Student.GetRegistration5}/${id}`);
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

// ===== SLICE =====
export const Slice = createSlice({
  name: "studentregistration",
  initialState: {
    data: [],

    status: IDS.SLICESTATUS.Idle,
    error: null,

    getUserData1: null,
    getUserData2: null,
    getUserData3: null,
    getUserData4: null,
    getUserData5: null,

    getUserStatus1: IDS.SLICESTATUS.Idle,
    getUserStatus2: IDS.SLICESTATUS.Idle,
    getUserStatus3: IDS.SLICESTATUS.Idle,
    getUserStatus4: IDS.SLICESTATUS.Idle,
    getUserStatus5: IDS.SLICESTATUS.Idle,

    getUserError1: null,
    getUserError2: null,
    getUserError3: null,
    getUserError4: null,
    getUserError5: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      // ===== REGISTRATION 1 =====
      .addCase(Create1.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(Create1.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.data.unshift(action.payload.data);
      })
      .addCase(Create1.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(GetRegistration1.pending, (state) => {
        state.getUserStatus1 = IDS.SLICESTATUS.Loading;
      })
      .addCase(GetRegistration1.fulfilled, (state, action) => {
        state.getUserStatus1 = IDS.SLICESTATUS.Succeeded;
        state.getUserData1 = action.payload.data;
      })
      .addCase(GetRegistration1.rejected, (state, action) => {
        state.getUserStatus1 = IDS.SLICESTATUS.Failed;
        state.getUserError1 = action.payload;
      })

      // ===== REGISTRATION 2 =====
      .addCase(Create2.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(Create2.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
      })
      .addCase(Create2.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })
      .addCase(GetRegistration2.pending, (state) => {
        state.getUserStatus2 = IDS.SLICESTATUS.Loading;
      })
      .addCase(GetRegistration2.fulfilled, (state, action) => {
        state.getUserStatus2 = IDS.SLICESTATUS.Succeeded;
        state.getUserData2 = action.payload.data;
      })
      .addCase(GetRegistration2.rejected, (state, action) => {
        state.getUserStatus2 = IDS.SLICESTATUS.Failed;
        state.getUserError2 = action.payload;
      })

      // ===== REGISTRATION 3 =====
      .addCase(Create3.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(Create3.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
      })
      .addCase(Create3.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })
      .addCase(GetRegistration3.pending, (state) => {
        state.getUserStatus3 = IDS.SLICESTATUS.Loading;
      })
      .addCase(GetRegistration3.fulfilled, (state, action) => {
        state.getUserStatus3 = IDS.SLICESTATUS.Succeeded;
        state.getUserData3 = action.payload.data;
      })
      .addCase(GetRegistration3.rejected, (state, action) => {
        state.getUserStatus3 = IDS.SLICESTATUS.Failed;
        state.getUserError3 = action.payload;
      })

      // ===== REGISTRATION 4 =====
      .addCase(Create4.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(Create4.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
      })
      .addCase(Create4.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })
      .addCase(GetRegistration4.pending, (state) => {
        state.getUserStatus4 = IDS.SLICESTATUS.Loading;
      })
      .addCase(GetRegistration4.fulfilled, (state, action) => {
        state.getUserStatus4 = IDS.SLICESTATUS.Succeeded;
        state.getUserData4 = action.payload.data;
      })
      .addCase(GetRegistration4.rejected, (state, action) => {
        state.getUserStatus4 = IDS.SLICESTATUS.Failed;
        state.getUserError4 = action.payload;
      })

      // ===== REGISTRATION 5 =====
      .addCase(Create5.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(Create5.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
      })
      .addCase(Create5.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })
      .addCase(GetRegistration5.pending, (state) => {
        state.getUserStatus5 = IDS.SLICESTATUS.Loading;
      })
      .addCase(GetRegistration5.fulfilled, (state, action) => {
        state.getUserStatus5 = IDS.SLICESTATUS.Succeeded;
        state.getUserData5 = action.payload.data;
      })
      .addCase(GetRegistration5.rejected, (state, action) => {
        state.getUserStatus5 = IDS.SLICESTATUS.Failed;
        state.getUserError5 = action.payload;
      });
  },
});

export default Slice.reducer;
